import { useCreditCard } from "@/hooks/useCreditCard";
import { useParams } from "react-router-dom";
import { showToast } from "@/utils";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Input } from "@/components";
import { EditIcon2 } from "@/styles/icons";
import { Button, Modal } from "barte-design-system";

interface RenameCreditCardProps {
    isOpen: boolean;
    onClose: ()=> void;
}
const renameSchema = z.object({
    cardName: z.string().optional(),
})
type RenameFormValues = z.infer<typeof renameSchema>

export default function RenameCreditCard({isOpen, onClose}: RenameCreditCardProps) {
    const {
        renameCreditCard,
        setSelectedCreditCardName
    } = useCreditCard();
    const { id } = useParams();
    const { execute, loading } = useAsyncFunction(renameCreditCard);
    const renameForm = useForm<any>({
        resolver: zodResolver(renameSchema),
        shouldFocusError: false,
    })

    async function onSubmit(data: RenameFormValues) {
        try {
            const formData = { idCard: id, cardName: data.cardName }
            await execute(formData);
            setSelectedCreditCardName(data.cardName);
            showToast({ type: "success", message: `Cartão renomeado com sucesso.` });
        } catch (error) {
            error?.response?.data?.errors.map((error) => {
                showToast({ type: "error", message: `${error?.code} - ${error?.description}` });
            });
        } finally {
            onClose();
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Renomear cartão"
            onClose={onClose}
            footer={{
                primaryButton: {
                    children: "Confirmar",
                    onClick: () => renameForm.handleSubmit(onSubmit)(),
                    loading,
                    disabled: loading || renameForm.watch("cardName") === "",
                },
                secondaryButton: { children: "Voltar", onClick: onClose, variant: "outline" },
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                <EditIcon2 size={24} />
                <Input
                    label="Nome do cartão"
                    placeholder="Renomear cartão"
                    name="cardName"
                    onChange={(e) => renameForm.setValue("cardName", e.target.value)}
                    register={{ ...renameForm.register("cardName") }}
                    errors={renameForm.formState.errors.cardName?.message}
                    maxLength={20}
                />
            </div>
        </Modal>
    );
}
